module.exports = __webpack_public_path__ + "static/media/bg-item-3.1af34b15.png";